import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';

@Component({
  selector: 'app-traveler-list',
  templateUrl: './traveler-list.component.html',
  styleUrls: ['./traveler-list.component.css']
})
export class TravelerListComponent implements OnInit {

  public menu_item_id = '92';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no', 
    'edit', 'del'];
  displayedColumns2 = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<TravelerComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'customer', 'customer_name': '', 'acct_number': '', 'mobile': '',
    'phone1': '', 'national_id': '', 'passport_no': '', 'branch_id': '-1', 'title': 'قائمة المسافرين'
  };
  branchList = [];
  Traveler_List; Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Traveler_List').subscribe((res: string) => {
      this.Traveler_List = res;
    });
    this.model['title'] = this.Traveler_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
            'branch_name_en': 'Common to all branches' });
        
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    let condition = "";

    if (this.model['acct_number'] != '')
      condition += " AND `customer`.`acct_number` = '" + this.model['acct_number'] + "'";

    if (this.model['customer_name'] != '')
      condition = " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.model['national_id'] != '')
      condition += " AND `customer`.`national_id` LIKE '%" + this.model['national_id'] + "%'";

    if (this.model['mobile'] != '')
      condition += " AND `customer`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      condition += " AND (`customer`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `customer`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.model['passport_no'] != '')
      condition += " AND `traveler_info`.`passport_no` LIKE '%" + this.model['passport_no'] + "%'";

    if (this.model['branch_id'] != '-1')
      condition += " AND `customer`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '-1') {
      let index = 1;
      let list_length = this.branchList.length;

      condition += " AND `customer`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '-1') {
          if (index < list_length)
            condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      condition += ")";
    }

    let query = "SELECT `customer`.*, `traveler_info`.*, `city`.`city_name`, `country`.`country_id`" +
      " FROM `customer`, `traveler_info`, `city`, `country` WHERE `customer`.`acct_number` = `traveler_info`.`acct_number`"
      + condition + " AND `customer`.`city_id` = `city`.`city_id` AND `city`.`country_id` = `country`.`country_id`" +
      " AND `customer`.`status` = '1'";

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        this.model['acct_number'] = '';
      });

  }

  newTraveler() {
    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
          // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
        }
      });
  }

  editTraveler(row) {
    let dialog_data = [{
      'table_name': 'customer', 'customer_id': row.customer_id,
      'customer_name': row.customer_name,
      'customer_name_en': row.customer_name_en,
      'customer_last_name': row.customer_last_name,
      'acct_number': row.acct_number,
      'national_id': row.national_id,
      'customer_category_id': row.customer_category_id,
      'city_id': row.city_id,
      'tax_no': row.tax_no,
      'address': row.address,
      'mobile': row.mobile,
      'phone1': row.phone1,
      'phone2': row.phone2,
      'fax': row.fax,
      'email': row.email,
      'bank_name': row.bank_name,
      'bank_acct_number': row.bank_acct_number,
      'represent1': row.represent1,
      'represent1_mobile': row.represent1_mobile,
      'represent2': row.represent2,
      'represent2_mobile': row.represent2_mobile,
      'customer_cr': row.customer_cr,
      'def_rep_no': row.def_rep_no,
      'claim_day': row.claim_day,
      'comment': row.comment,
      'key': 'customer_id',
      'flag': 'update',
      'car_type': row.car_type,
      'car_model': row.car_model,
      'car_color': row.car_color,
      'is_account': row.is_account
    }, { 'country_id': row.country_id }];

    this.addDialogRef = this.dialog.open(TravelerComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.model['acct_number'] = result['acct_number'];
          this.search();
          // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
        }
      });

  }

  delTraveler(row) { 
    if (confirm(this.Del_Msg)) {

      let values = [{ 'table_name': this.model['table_name'], 'acct_number': row.acct_number },
        { 'table_name': 'traveler_info', 'acct_number': row.acct_number },
        { 'table_name': 'sub_acct', 'acct_number': row.acct_number }];

      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.model['acct_number'] = row.acct_number;
            this.search();
            // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Traveler_List + ' </td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('customer_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
